import {
  assign, filter
} from "../common/utils";

/*
训练:信息
*/
export function KGame(rawData) {
  const R = assign({
    "gameId": 0,
    "cupId": 0,
    "uid": 0,
    "tradingDay": "",
    "predictNum": 0,
    "status": 0,
    "beginTime": "",
    "endTime": "",
    "gameScore": 0,
    "mtime": "",
    "ctime": "",
    "actionList": []
  }, rawData);
  R.gameId = +R.gameId;

  // 格式化 actionList
  const actionList = filter(R.actionList, o => !!o && o.kid > 0)
  R.actionList = actionList
  
  return R;
}

/*
训练:动作
*/
// function TGameAction(rawData) {
//   var R = {
//       actionId: 0,
//       gameId: 0,
//       step: 0, // step int
//       action: 0, // action int 1买入 2持仓 3卖出 4观望
//       time: 0,
//       ctime: "0",
//       actionName: "",
//       actionText: ""
//     },
//     O;
//   R = XUtils.assign(R, rawData);
//   O = MapKActions[R.action] || {};
//   R.actionName = O.name || "" + R.action;
//   R.actionText = O.text || "" + R.action;
//   return R;
// }
